import Vue from 'vue'
import App from './App.vue'

import router from './router'

Vue.config.productionTip = false
// import '@/utils/request'
//引入全局样式
import './assets/reset.css'
//引入轮播图组件
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.min.css'
//注册全局组件
Vue.component('Swiper', Swiper);
Vue.component('SwiperSlide', SwiperSlide)
//引入仓库
import store from './store'

//引入element-UI组件库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// VueAMap.initAMapApiLoader({
//   key: 'fe5bef0bb9bc3c23757de73005a84442',
//   plugin: [ // 这里根据自己项目按需引入插件
//     'AMap.Autocomplete', 
//     'AMap.PlaceSearch', 
//     'AMap.Scale',
//     'AMap.OverView', 
//     'AMap.ToolBar',
//     'AMap.MapType',
//     'AMap.PolyEditor', 
//     'AMap.CircleEditor',// 圆形编辑器插件
//     "AMap.Geolocation", // 定位控件，用来获取和展示用户主机所在的经纬度位置
//     "AMap.Geocoder", // 地理编码与逆地理编码服务，用于地址描述与坐标间的相互转换
//     "AMap.CitySearch",
//   ]
// });
// window._AMapSecurityConfig = {
//   securityJsCode:'743c444b06d3a2e8b61ed9b0bd6b2a2c',
// }
// // 解决高德地图刷新显示不出来
// const amapKeys = Object.keys(localStorage).filter(key => key.match(/^_AMap_/))
// amapKeys.forEach(key => { localStorage.removeItem(key) })

// import './plugins/element.js'

//路由鉴权文件:全局导航守卫判断
// import '@/permisstion'; 

//创建vm
new Vue({
  render: h => h(App),
  router,
  store,
  // beforeCreate() {
  //   //Vue.prototype.xxx->只要是VC都可以使用
  //   Vue.prototype.$bus = this;
  //   //把全部的请求方法挂载到原型对象身上
  //   Vue.prototype.$http = http;
  // }
}).$mount('#app')
